import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import OptionChooser from 'Components/OptionChooser';
import BlockWrapper from 'Components/_NewElements/BlockWrapper';
import { des } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import { useMyServiceContext } from 'Routes/MyService/Document';
import colors from '../../../../../config/theme/colors';
import browserLanguage from 'Utility/browserLanguage';
import { useAppSelector } from 'Store/index';

export const Des = (): React.JSX.Element => {
  const locale = useAppSelector(s => s.settings.userSettings.uiLanguage) ?? browserLanguage;
  const { editing, setEditingData, viewing, setViewingObj, setEditingObj } = useMyServiceContext<'des'>();

  const desData = editing?.data ?? viewing?.data ?? {};
  const desLocales = des.getLocalizations(locale);

  const onChangeSurveyForm = (values: TOnChangeValues): void => {
    const field = Object.keys(values)[0];
    if (!field) return;
    let value = Object.values(values)[0];

    if (field === 'dyspneaIntensity' && typeof value === 'number') {
      value = {
        1: 'canWalkAtOwnPaceRegardlessOfDistance',
        2: 'dyspneaWhenWalkingAtOwnPaceOver100Meters',
        3: 'dyspneaWhenWalkingAtOwnPaceAtHomeOrInTheWard',
        4: 'dyspneaWhenMovingInBedOrGettingUp',
        5: 'dyspneaWhenTalking',
        6: 'dyspneaAtRest',
      }[value];
    }

    setEditingData?.({
      ...desData,
      [field]: value,
    });
  };

  const fmDES = (id: string) => desLocales[id];

  return (
    <>
      {!viewing ? (
        <div style={{ width: '80%', color: colors.tertiaryText, marginBottom: '2rem' }}>
          <p>{desLocales.surveyInfo}</p>
          <p>{desLocales.surveyFillingInfo}</p>
        </div>
      ) : null}
      <BlockWrapper
        title={viewing ? formatPartialDate(desData.date) : undefined}
        buttons={
          viewing
            ? [
                {
                  title: 'general.edit',
                  onClick: () => {
                    setViewingObj(null);
                    setEditingObj({ type: 'des', data: desData });
                  },
                },
              ]
            : undefined
        }
      >
        {!viewing ? (
          <React.Fragment>
            <FormRow title={'general.date'} headerWidth={2}>
              <InputHandler
                name="date"
                type="PartialDate"
                dateDefault="now"
                formData={{
                  document: { date: desData.date },
                  onChange: onChangeSurveyForm,
                }}
                editing={!!editing}
              />
            </FormRow>
            <OptionChooser
              name="dyspneaIntensity"
              formData={{
                document: {
                  dyspneaIntensity:
                    typeof desData.dyspneaIntensity === 'string'
                      ? {
                          canWalkAtOwnPaceRegardlessOfDistance: 1,
                          dyspneaWhenWalkingAtOwnPaceOver100Meters: 2,
                          dyspneaWhenWalkingAtOwnPaceAtHomeOrInTheWard: 3,
                          dyspneaWhenMovingInBedOrGettingUp: 4,
                          dyspneaWhenTalking: 5,
                          dyspneaAtRest: 6,
                        }[desData.dyspneaIntensity]
                      : undefined,
                },
                onChange: onChangeSurveyForm,
              }}
              opts={[1, 2, 3, 4, 5, 6]}
              optionFormatter={(name: string | number) =>
                typeof name === 'number' ? (
                  <span>
                    {fmDES(
                      `opts.${
                        {
                          1: 'canWalkAtOwnPaceRegardlessOfDistance',
                          2: 'dyspneaWhenWalkingAtOwnPaceOver100Meters',
                          3: 'dyspneaWhenWalkingAtOwnPaceAtHomeOrInTheWard',
                          4: 'dyspneaWhenMovingInBedOrGettingUp',
                          5: 'dyspneaWhenTalking',
                          6: 'dyspneaAtRest',
                        }[name]
                      }`,
                    )}
                  </span>
                ) : (
                  <span />
                )
              }
              viewing={!!viewing}
              horizontal
              minHeight={15}
            />
          </React.Fragment>
        ) : desData.dyspneaIntensity ? (
          <span style={{ fontWeight: 600 }}>{fmDES(`opts.${desData.dyspneaIntensity}`)}</span>
        ) : null}
      </BlockWrapper>
    </>
  );
};
